import { DOCUMENT } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { Component, Inject, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Services } from "@smdapp/shared/services";
import { CodigoErroConstante } from "../../shared/constants/codigo-erro.constant";
import { ErroApp } from "../../shared/models/erro-app.model";

@Component({
    selector: 'app-acesso-gov-br',
    templateUrl: './acesso-gov-br.component.html',
    styleUrls: ['./acesso-gov-br.component.scss']
})

export class AcessoGovBrComponent {

    @Input() returnUrlParam: string;
    @Input() contarErro: number;
    @Input() _disabled: boolean;

    @Input() set disabled(val:  boolean)
    {
        this._disabled = val;
    }
    get disabled(): boolean{ return this._disabled; }


    constructor(private activeRoute: ActivatedRoute,
        private svc: Services,
        @Inject(DOCUMENT) protected document: Document)
    {

    }

    public redirecionaAcessoGovBr() {
        this.svc.logger.debug('[redirecionaAcessoGovBr] Redirecionando...');
        this.svc.acessoExternoService.redirecionaAcessoGovBr()
            .then((acessoExternoEmailDTO: any) => {
                if(acessoExternoEmailDTO && acessoExternoEmailDTO.urlDestino)
                {
                    const urlPrcGovBr = acessoExternoEmailDTO.urlDestino;
                    this.svc.logger.debug('[redirecionaAcessoGovBr] URL GOV BR: ', urlPrcGovBr+'?govbr=true&' + this.returnUrlParam);
                    this.document.location.href = urlPrcGovBr+'?govbr=true&' + this.returnUrlParam ;
                }else
                {
                    this.svc.logger.error('[redirecionaAcessoGovBr] Erro ao obter redirecionamento para GOV.BR');
                    this.svc.bnAlertService.alertaErro('Erro', 'Não foi possível realizar o acesso utilizando GOV.BR');
                    this.contarErro++;
                }
                return;
            })
            .catch((error: any) =>
            {
              if (error instanceof HttpErrorResponse) {
                    this.svc.bnAlertService.alertaErro(`Erro ${error.status}`, error.message);
              }
              else {
                    this.svc.logger.error('[redirecionaAcessoGovBr] Erro ao realizar acesso externo GOV.BR', error);
                    this.svc.bnAlertService.alertaErro('Erro', error.cabecalho + ' Não foi possível realizar o acesso utilizando GOV.BR', error.listaComentarios);
                    this.contarErro++;
              }
            });
    }
}
